import { cn, ensureHrefProtocol } from '@/lib/utils';

interface ExternalLinkProps {
  href: string;
  text: string;
  className?: string;
  noopener?: boolean;
  noreferrer?: boolean;
}

function ExternalLink({
  href,
  text,
  className,
  noopener = true,
  noreferrer = true,
}: ExternalLinkProps) {
  const normalizedHref = ensureHrefProtocol(href);
  const rel =
    [noopener && 'noopener', noreferrer && 'noreferrer'].filter(Boolean).join(' ') || undefined;

  return (
    <a
      href={normalizedHref}
      target="_blank"
      rel={rel}
      className={cn('text-text-link hover:text-text-link-hovered', className)}
    >
      {text}
    </a>
  );
}

export { ExternalLink };
